import { ref } from 'vue';

const tradeResult = ref<any>({});
const tradeArray = ref<any[]>([]);

export const useTrade = () => {
  const resetTrade = () => {
    tradeResult.value = {};
    tradeArray.value = [];
  };

  return {
    tradeResult,
    tradeArray,
    resetTrade
  };
}; 